import { Skeleton, Tab, Tabs } from '@heroui/react';
import { List, ViewGrid } from 'iconoir-react';
import { useQueryState } from 'nuqs';

import { useContentHeaderContext } from './ContentHeaderContext';

export type ContentHeaderViewToggleProps = {
  'data-testid'?: string;
  /** View selected when the URL has no `view` parameter. */
  defaultView?: 'grid' | 'list';
};

export function ContentHeaderViewToggle(props: ContentHeaderViewToggleProps) {
  const { 'data-testid': dataTestId, defaultView = 'grid' } = props;
  const [view, setView] = useQueryState('view', {
    defaultValue: defaultView
  });
  // An empty or unknown `view` must not reach the tabs: they would select the first tab and
  // write it back to the URL.
  const selectedView = view === 'grid' || view === 'list' ? view : defaultView;

  const { isLoaded } = useContentHeaderContext('ContentHeaderViewToggle');

  if (!isLoaded) {
    return <Skeleton className='h-[28x] w-[64px] rounded-md' />;
  }

  return (
    <Tabs
      aria-label='View toggle'
      variant='bordered'
      className=''
      classNames={{
        tabList: 'gap-1 p-[2px] bg-surface-container-low relative'
      }}
      defaultSelectedKey={selectedView}
      onSelectionChange={key => setView(key as string)}
      data-testid={dataTestId}
    >
      <Tab
        key='grid'
        className='h-6 w-7 px-1.5 py-1'
        title={<ViewGrid className='icon-smallest' />}
      />
      <Tab
        key='list'
        className='h-6 w-7 px-1.5 py-1'
        title={<List className='icon-smallest' />}
      />
    </Tabs>
  );
}
